import { Component, OnInit } from '@angular/core';
import { MonografieService } from './monografie.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'monografie',
  templateUrl: './monografie.component.html',
  styleUrls: ['./monografie.component.scss'],
  providers: [MonografieService]

})

export class MonografieComponent implements OnInit {

  modelList: any[] = [];
  promiseBusy: Promise<any[]>;

  // Base per i PDF (dominio pubblico, non l'API con porta)
  websiteUrl = `${environment.publicSiteBase}/docs/documenti_pdf/`;
  //websiteUrl = 'https://centrofunzionale-coll.regione.campania.it/docs/documenti_pdf/';
  constructor(private restService: MonografieService) { }

  ngOnInit() {
    this.createDocumentiList();
  }

  createDocumentiList() {
    this.restService.selectAll().then(
      res => {
        if (!res || res.length === 0) { 
          this.modelList = [];
          return;
        }
        
        let modelAggregate = {}; 
        
        res.documentiBindList.forEach(item => {
          let tipo = item.idCategoria;
  
          if (!modelAggregate[tipo]) {
            modelAggregate[tipo] = {
              idCategoria: tipo,
              elements: []
            };
          }
  
          modelAggregate[tipo].elements.push({
            url: item.url,
            descrizione: item.descrizione
          });
        });
  
        
        this.modelList = Object.values(modelAggregate);
        
      }
    ).catch(error => {
      this.modelList = [];
    });
  }
}
